import React from 'react';
import { entityVisibility } from '@/constants/states';
import { visibilityIcon } from '@/constants/images';
import FilterToggles from './FilterToggles';

export const visibilityFilter = (active, entity, onClick, visibility) => ({
  active,
  icon: visibilityIcon[visibility],
  key: `${entity}${visibility}`,
  messageId: `${entity}.visibility.filter.${visibility}`,
  onClick,
});

const VisibilityFilterToggles = ({
  children,
  entity,
  internalFlag,
  privateFlag,
  updateFlags,
}) => (
  <FilterToggles filters={[
    visibilityFilter(
      privateFlag,
      entity,
      () => updateFlags({ privateFlag: !privateFlag, internalFlag }),
      entityVisibility.PRIVATE,
    ),
    visibilityFilter(
      internalFlag,
      entity,
      () => updateFlags({ privateFlag, internalFlag: !internalFlag }),
      entityVisibility.INTERNAL,
    ),
  ]}
  >
    {children}
  </FilterToggles>
);

export default VisibilityFilterToggles;
